import { DocumentEditorPage } from '@jarvis/platform-ui';

export function WordEditorPage() {
  return (
    <DocumentEditorPage
      mode="edit"
      kind="richedit"
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
